import CategoryManagementLandingPage from "../../components/categoryManagement/CategoryManagementLandingPage";

export default CategoryManagementLandingPage;
